// extracted by mini-css-extract-plugin
export default {"container":"AddressManuallyFields__container--bMA","linkAddressWrap":"AddressManuallyFields__linkAddressWrap--3t-","linkAddress":"AddressManuallyFields__linkAddress--2Ht"};